var map = {
	"./dell.svg": "1132",
	"./hp.svg": "dd3b",
	"./hpe.svg": "c620",
	"./huawei.svg": "a82a",
	"./inspur.svg": "165a",
	"./lenovo.svg": "41d1",
	"./supermicro.svg": "307f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d38c";